export const ChatBack = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.298 0.603176L4.19324 0.5625C2.36345 0.5625 0.875 2.1082 0.875 4.00836V7.56579C0.875 7.72037 0.933755 7.86796 1.03895 7.97721C1.14415 8.08587 1.28628 8.14688 1.43457 8.14688C1.43457 8.14688 1.43513 8.14688 1.43569 8.14688L15.4629 8.11667C20.4716 8.11667 21.0194 9.29105 21.0194 12.7247V25.0095C21.0194 25.0624 21.0138 25.1147 21.0116 25.167L21.7245 25.9811C21.8325 26.1043 21.9836 26.1711 22.1386 26.1711C22.2063 26.1711 22.2746 26.1583 22.3406 26.1322C22.556 26.0456 22.6981 25.83 22.6981 25.59V19.7791H23.2969C25.1267 19.7791 26.6151 18.2334 26.6151 16.3339V4.04904C26.6151 2.14888 25.1267 0.603176 23.298 0.603176Z"
      fill="white"
    />
  </svg>
);

export const ChatFront = () => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.5448 0.279297H3.36121C1.53142 0.279297 0.0429688 1.825 0.0429688 3.72458V16.0094C0.0429688 17.9096 1.53142 19.4553 3.36121 19.4553H6.75778V25.2662C6.75778 25.5061 6.89991 25.7217 7.11591 25.8083C7.18138 25.8345 7.24964 25.8472 7.31735 25.8472C7.47179 25.8472 7.62343 25.7804 7.73143 25.6572L13.1604 19.4553H23.5448C25.3746 19.4553 26.8631 17.9096 26.8631 16.01V3.72516C26.8631 1.825 25.3746 0.279297 23.5448 0.279297Z"
      fill="white"
    />
  </svg>
);

export const RightPointer = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-12 w-20 -ml-5"
    fill="none"
    style={{ color: "#696969" }}
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  </svg>
);

export const LeftPointer = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-12 w-20 -ml-5"
    fill="none"
    style={{ color: "#696969" }}
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
  </svg>
);

export const LocationPin = () => (
  <svg
    width="14"
    height="19"
    viewBox="0 0 14 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.56957 0.758789C2.96433 0.758789 0.03125 3.80667 0.03125 7.55296C0.03125 9.10159 1.07931 11.3962 3.14634 14.3731C4.65531 16.5462 6.18623 18.3167 6.20149 18.3343L6.56952 18.7588L6.93755 18.3343C6.95285 18.3167 8.48372 16.5463 9.99269 14.3731C12.0597 11.3962 13.1078 9.10159 13.1078 7.55296C13.1078 3.80667 10.1748 0.758789 6.56957 0.758789ZM6.56952 17.2122C4.73368 15.0145 1.02209 10.0542 1.02209 7.55296C1.02204 4.37438 3.51065 1.78836 6.56957 1.78836C9.62848 1.78836 12.117 4.37438 12.117 7.55296C12.117 10.0527 8.40535 15.0139 6.56952 17.2122Z"
      fill="black"
    />
  </svg>
);

export const DropdownIcon = () => (
  <svg
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.898438 0.568359L6.20543 5.77669L11.5124 0.568359H0.898438Z"
      fill="black"
    />
  </svg>
);

export const CategoryIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 8 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.07978 1.45727L3.3377 1.94712L3.65293 2.55807H6.08311V5.31009H1.49787V1.45727H3.07978ZM3.43514 0.356459H0.924717C0.772707 0.356459 0.626923 0.414447 0.519436 0.517668C0.411948 0.620888 0.351563 0.760886 0.351562 0.906862V5.86049C0.351563 6.00647 0.411948 6.14646 0.519436 6.24969C0.626923 6.35291 0.772707 6.41089 0.924717 6.41089H6.65627C6.80828 6.41089 6.95406 6.35291 7.06155 6.24969C7.16903 6.14646 7.22942 6.00647 7.22942 5.86049V2.00767C7.22942 1.86169 7.16903 1.72169 7.06155 1.61847C6.95406 1.51525 6.80828 1.45727 6.65627 1.45727H4.36365L3.95097 0.65918C3.90291 0.567573 3.82914 0.490689 3.738 0.4372C3.64685 0.38371 3.54195 0.355745 3.43514 0.356459Z"
      fill="black"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3297 14.277L10.9468 10.0657C11.8108 9.0707 12.3305 7.79918 12.3305 6.41042C12.3305 3.24213 9.62249 0.666016 6.29144 0.666016C2.9604 0.666016 0.246094 3.24514 0.246094 6.41343C0.246094 9.58172 2.95413 12.1578 6.28518 12.1578C7.70025 12.1578 9.00262 11.6919 10.0357 10.9134L14.4344 15.1368C14.6911 15.3832 15.073 15.3832 15.3297 15.1368C15.5864 14.8903 15.5864 14.5235 15.3297 14.277ZM1.52967 6.41343C1.52967 3.92449 3.6648 1.90147 6.28518 1.90147C8.90556 1.90147 11.0407 3.92449 11.0407 6.41343C11.0407 8.90237 8.90556 10.9254 6.28518 10.9254C3.6648 10.9254 1.52967 8.89936 1.52967 6.41343Z"
      fill="black"
    />
  </svg>
);

export const HomeIcon = () => (
  <svg
    aria-hidden="true"
    className="w-4 h-4 mr-2"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
  </svg>
);

export const RightPointerMin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="12"
    width="12"
    fill="white"
    className="text-white"
  >
    <path d="m15.2 43.9-2.8-2.85L29.55 23.9 12.4 6.75l2.8-2.85 20 20Z" />
  </svg>
);

export const PricingLogo = () => (
  <svg
    width="48"
    height="55"
    viewBox="0 0 48 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_201_10906)">
      <path
        d="M5 11.9091L22.7333 1L43 11.9091V34.4091L22.7333 46L5 34.4091V11.9091Z"
        fill="white"
      />
      <path
        d="M5 11.9091L22.7333 1L43 11.9091V34.4091L22.7333 46L5 34.4091V11.9091Z"
        stroke="#FAFAFA"
      />
    </g>
    <g filter="url(#filter1_d_201_10906)">
      <path
        d="M18 17.4483L24.8824 14L31 23.6552L22.5882 34L18 31.2414L24.8824 23.6552L18 17.4483Z"
        fill="#08AC04"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_201_10906"
        x="0.5"
        y="0.422852"
        width="47"
        height="54.1631"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_201_10906"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_201_10906"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_201_10906"
        x="14"
        y="14"
        width="21"
        height="28"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_201_10906"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_201_10906"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const Pricing12 = () => (
  <svg
    width="55"
    height="31"
    viewBox="0 0 55 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.86225 30.8H9.52625V26.352C13.5583 26 16.3743 23.344 16.3743 19.824C16.3743 16.592 14.6143 14.736 9.68625 12.656V5.008C11.1583 5.072 11.6383 5.424 11.7663 6.512C11.9583 8.496 12.3103 9.232 13.9743 9.232C15.1263 9.232 16.0223 8.432 16.0223 7.312C16.0223 5.584 14.1663 3.696 9.68625 3.568V0.655998H8.02225V3.6C4.24625 4.016 1.62225 6.512 1.62225 9.712C1.62225 12.752 3.22225 14.704 7.86225 16.56V24.912C5.68625 24.816 5.30225 24.336 5.17425 23.088C4.95025 20.656 4.27825 20.4 2.90225 20.4C1.84625 20.4 0.95025 20.976 0.95025 22.224C0.95025 24.464 3.06225 26.192 7.86225 26.352V30.8ZM12.6623 21.296C12.6623 23.248 11.7343 24.624 9.52625 24.88V17.264C11.9263 18.416 12.6623 19.6 12.6623 21.296ZM5.01425 8.144C5.01425 6.448 6.07025 5.328 8.02225 5.04V11.952C5.71825 10.832 5.01425 9.872 5.01425 8.144Z"
      fill="#08AC04"
    />
    <path
      d="M27.0575 26H37.3935V24.848L35.8895 24.592C34.8975 24.4 34.7055 24.24 34.7055 22.48V3.728L33.6815 3.568C32.0495 5.392 30.1295 6.64 27.0255 7.28V8.464L29.9375 8.56V22.48C29.9375 24.24 29.6495 24.4 28.6895 24.592L27.0575 24.848V26ZM39.1728 26H54.2128L54.6928 20.016H53.6368C52.5488 22.256 52.2928 22.544 50.5968 22.544H43.1088V22.384C49.3488 18.512 54.6287 14.448 54.6287 9.84C54.6287 5.552 51.3008 3.44 46.7888 3.44C42.0208 3.44 39.7488 5.232 39.7488 7.12C39.7488 8.432 40.4848 9.168 41.8608 9.168C43.4288 9.168 44.1648 8.368 44.2928 6.384C44.4208 5.296 44.8048 4.848 46.3728 4.848C48.2928 4.848 49.8608 6.128 49.8608 9.36C49.8608 13.008 48.4848 14.928 46.0848 17.552C44.3568 19.472 41.9888 21.648 39.1728 23.856V26Z"
      fill="black"
    />
  </svg>
);
